import '../styles/tailwind.css'
import React from 'react'
import PrimaryButton from '../components/Button/PrimaryButton'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons'
import SummaryStats from '../sections/SummaryStats'
import PendaftarTable from '../sections/PendaftarTable'
import { UserContextProvider } from '../context/UserContext'
import AnggotaAktifTable from '../sections/AnggotaAktifTable'
import Layout from '../components/Layout'
import { useRegistrationCounts } from '../hooks/useRegistrations'
import { SummarySkeleton } from '../components/Skeleton'

const Home = ({ onLogout }) => {
  // Tabel pendaftar mengambil datanya sendiri per halaman. Di sini kita cuma
  // butuh angka untuk kartu ringkasan, jadi yang diambil totalnya saja.
  const { counts, isLoading } = useRegistrationCounts()

  return (
    <UserContextProvider>
      <Layout>
        <div className="px-3 py-3 lg:pl-0 lg:pr-4 lg:py-3">
          {/* Lapisan kaca abu di bawah kartu-kartu putih: memberi satu bingkai
              untuk seluruh isi dashboard.

              Jangan tambahkan backdrop-filter / filter / transform di sini:
              properti itu membuat elemen ini jadi containing block untuk
              posisi fixed, sehingga modal di dalamnya (mis. detail pendaftar)
              ikut memanjang mengikuti panel dan muncul jauh di bawah layar,
              bukan di tengah viewport. */}
          <div className="flex flex-col gap-3 rounded-panel border border-white/70 bg-white/40 shadow-glass p-3 lg:p-4">
            <div className="rounded-card border border-line bg-white shadow-card px-4 py-3 flex flex-wrap items-center justify-between gap-3">
              <div>
                <div className="text-lg font-bold text-ink">Dashboard</div>
                <div className="text-[13px] text-muted">
                  Ringkasan pendaftar dan anggota aktif
                </div>
              </div>
              <PrimaryButton onClick={() => onLogout()}>
                Log Out <FontAwesomeIcon icon={faRightFromBracket} />
              </PrimaryButton>
            </div>
            {isLoading ? (
              <SummarySkeleton />
            ) : (
              <SummaryStats
                pendaftarOnline={counts.belumVerifikasi}
                verifiedKorwil={counts.verifKorwil}
                disetujui={counts.disetujui}
                total={counts.total}
              />
            )}
            <PendaftarTable />
            <AnggotaAktifTable />
          </div>
        </div>
      </Layout>
    </UserContextProvider>
  )
}

export default Home
